import { AlertService } from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssessmentService } from "../../shared/services/assessment.service";
import { QuestionSet } from "../../shared/models/question-set";
import { DisplayCondition } from "../../shared/models/display-condition";
import { QuestionSetType } from "../../shared/models/question-set-type";
var QuestionSetEditComponent = /** @class */ (function () {
    function QuestionSetEditComponent(_assessmentService, route, router, location, alertService) {
        this._assessmentService = _assessmentService;
        this.route = route;
        this.router = router;
        this.location = location;
        this.alertService = alertService;
        this.questionSet = new QuestionSet();
    }
    QuestionSetEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var setId = params['setId'];
            _this._assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
                _this.questionSet = assessment.question_sets.find(function (s) { return s.id == setId; });
                console.log(_this.questionSet);
                if (!_this.questionSet) {
                    // TODO: stephen should we navigate back?? or do some kind of 404?
                    _this.router.navigate(["not-found"]);
                }
            });
        });
    };
    Object.defineProperty(QuestionSetEditComponent.prototype, "Assessment", {
        get: function () {
            return this.assessment;
        },
        enumerable: true,
        configurable: true
    });
    QuestionSetEditComponent.prototype.hasConditions = function (questionSet) {
        return questionSet.display_conditions && questionSet.display_conditions.length > 0;
    };
    QuestionSetEditComponent.prototype.toggleCondition = function (questionSet) {
        if (this.hasConditions(questionSet)) {
            questionSet.display_conditions = [];
        }
        else {
            // set it with a new display condition
            questionSet.display_conditions.push(new DisplayCondition());
        }
    };
    Object.defineProperty(QuestionSetEditComponent.prototype, "Condition", {
        get: function () {
            return this._questionSet.display_conditions[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSetEditComponent.prototype, "questionSet", {
        get: function () {
            return this._questionSet;
        },
        set: function (v) {
            this._questionSet = v;
        },
        enumerable: true,
        configurable: true
    });
    QuestionSetEditComponent.prototype.goBack = function () {
        this.location.back();
    };
    QuestionSetEditComponent.prototype.moveDownLabel = function (label) {
        this.questionSet.shiftLabelDown(label);
        this.save();
    };
    QuestionSetEditComponent.prototype.moveUpLabel = function (label) {
        this.questionSet.shiftLabelUp(label);
        this.save();
    };
    QuestionSetEditComponent.prototype.moveUpQuestion = function (question) {
        this.questionSet.shiftQuestionUp(question);
        this.save();
    };
    QuestionSetEditComponent.prototype.moveDownQuestion = function (question) {
        this.questionSet.shiftQuestionDown(question);
        this.save();
    };
    QuestionSetEditComponent.prototype.save = function () {
        var _this = this;
        this._assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Question Set saved");
        }).catch(function (error) {
            _this.alertService.error("Question Set failed to save.  Please try again or contact customer support.");
            console.error(error);
        });
    };
    QuestionSetEditComponent.prototype.deleteQuestion = function (question) {
        if (!confirm("Are you sure you want to delete this question?")) {
            return;
        }
        this.questionSet.removeQuestion(question);
        // TODO: stephen need messaging for removing a question, at least if it fails
        this.saveDeleteItem(this.assessment);
    };
    QuestionSetEditComponent.prototype.deleteLabel = function (label) {
        if (!confirm("Are you sure you want to delete this label?")) {
            return;
        }
        this.questionSet.removeLabel(label);
        this.saveDeleteItem(this.assessment);
    };
    QuestionSetEditComponent.prototype.showQuestionLabelsForType = function (type) {
        if (type != QuestionSetType[type]) {
            return true;
        }
        return false;
    };
    QuestionSetEditComponent.prototype.saveDeleteItem = function (assessment) {
        var _this = this;
        this._assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.error("Item deleted.");
        }).catch(function (error) {
            _this.alertService.error("Failed to delete item.  Please try again or contact customer support.");
            console.error(error);
        });
    };
    return QuestionSetEditComponent;
}());
export { QuestionSetEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/question-set-edit/question-set-edit.component.ts.pre-build-optimizer.js